import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FiltersService {
    private filtersSubject$: BehaviorSubject<any>;
    public filters$: Observable<any>;
    
    private filtersDataSubject$: BehaviorSubject<any>;
    public filtersData$: Observable<any>;

    constructor(private http: HttpClient) {
        this.filtersSubject$ = new BehaviorSubject<any>(null);
        this.filters$ = this.filtersSubject$.asObservable();

        this.filtersDataSubject$ = new BehaviorSubject<any>(null);
        this.filtersData$ = this.filtersDataSubject$.asObservable();
    }

    public get filtersValue(): any {
        return this.filtersSubject$.value;
    }

    setFiltersEvent(val) {
        this.filtersSubject$.next(val);
    }

    public get filtersDataValue(): any {
        return this.filtersDataSubject$.value;
    }

    setFiltersDataEvent(val) {
        this.filtersDataSubject$.next(val);
    }
}
